import { Component } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  standalone: false
})
export class SuccessComponent {
  pid: any;
  method: any;
  order_id: any;
  event_id: any;
  mem_id: any;
  name: any;
  event_name: any;
  event_image: any;
  send_whatsapp_reg: any;
  mobile: any;
  email: any;
  reg_whatsapp_msg: any;
  hasNavigated: boolean = false;  // Flag to prevent navigation loop

  constructor(
    private service: ServicesService,
    private PlatformLocation: PlatformLocation,
    private router: Router,
    private route: ActivatedRoute
  ) {

    history.pushState(null, '', location.href);
    this.PlatformLocation.onPopState(() => {
      history.pushState(null, '', location.href);
    })
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: any) => {
      this.pid = params.get('pid');
      this.event_id = params.get('event_id');
      this.get_payment_details(this.pid, this.event_id);
    });
  }

  get_payment_details(pid: any, event_id: any) {
    this.service.get_payment_details(pid, event_id).subscribe(
      (data: any) => {
        const affected_rows = data.affected_rows;
        if (affected_rows == 1) {
          console.log(1);
          this.method = data.method;
          this.order_id = data.order_id;
          this.event_id = data.notes.event_id;
          this.mem_id = data.notes.mem_id;

          this.get_reg_by_id_web(this.event_id, this.mem_id);
          this.Get_Event_By_Id(this.event_id);
          this.Get_Setting(this.event_id);
        } else {
          console.log(2);
          alert("BAD_REQUEST_ERROR")
          this.router.navigate(['/Registration/' + this.event_id]);
        }


      });
  }

  Get_Event_By_Id(event_id: any) {
    this.service.get_event_by_id(event_id).subscribe(
      (data: any) => {
        this.event_name = data.data[0].event_name;
        this.event_image = data.data[0].event_image;

      });
  }

  get_reg_by_id_web(event_id: any, mem_id: any) {
    this.service.get_reg_by_id_web(event_id, mem_id).subscribe({
      next: (data: any) => {
        this.name = data.data[0].name;
        this.mobile = data.data[0].mobile;
        this.email = data.data[0].email;
      },
      error: (error: any) => {
        console.error('Error fetching registration data:', error);
      }
    });
  }

  Get_Setting(event_id: any) {
    this.service.getsetting(event_id).subscribe(
      (data: any) => {
        this.send_whatsapp_reg = data.data[0].send_whatsapp_reg;
        this.reg_whatsapp_msg = data.data[0].reg_whatsapp_msg;

        if (this.send_whatsapp_reg == 'yes') {
          this.service.Generate_Card1(this.mem_id, this.event_id).subscribe(
            () => {

              const whatsapp_data = {
                mem_id: this.mem_id,
                name: this.name,
                mobile: this.mobile,
                email: this.email,
              }
              this.service.Send_Whatsapp(whatsapp_data, this.event_id, this.reg_whatsapp_msg).subscribe(
                () => {
                  console.log("SUCCESS: ID CARD SENT ON WHATSAPP");
                  this.navigateToRegistrationPage();
                }
              );

            }
          );
        } else {
          console.log("SUCCESS");
          this.navigateToRegistrationPage();
        }
      })
  }

  navigateToRegistrationPage() {
    setTimeout(() => {
      this.router.navigate(['/Registration/' + this.event_id]);  // Update with the actual route path for registration page
    }, 15000); // 15 seconds delay
  }

}
